<template>
  <custom-callout
    :border-color="getColorStatus(value.proposalServiceStatusId, true)"
    class="mb-3 callout"
    :has-toggle="false"
    :opened="isOpen"
  >
    <div class="row mt-2 row-container">
      <div class="col-md-2 col-12 border-right status">
        <div class="row align-items-center">
          <div class="col-7 col-md-12">
            <custom-balloon
              :background-color="
                ` bg-${getColorStatus(value.proposalServiceStatusId)}`
              "
              class="w-md-90 w-100"
              :text="value.proposalServiceStatus"
            />
          </div>
          <div v-if="isAdmin" class="col-12 d-none d-md-block mt-md-4">
            <span class="info">
              {{ value.proposalNumber }}
            </span>
          </div>
          <div v-if="isAdmin" class="col-12 d-none d-md-block">
            <div class="label">Fecha:</div>
            <span class="info">
              {{ value.date | date }}
            </span>
          </div>
          <div v-if="isAdmin" class="col-12 d-none d-md-block mt-md-4">
            <div class="label">Tipo de Proponente:</div>
            <span class="info">
              {{ value.recruitmentType }}
            </span>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-10">
        <div class="row">
          <div v-if="isAdmin" class="col-12 d-block d-md-none">
            <div class="label">Número de Propuesta:</div>
            <span class="info">
              {{ value.proposalNumber }}
            </span>
          </div>
          <div v-if="isAdmin" class="col-12 d-block d-md-none">
            <div class="label">Fecha:</div>
            <span class="info">
              {{ value.date | date }}
            </span>
          </div>
          <div class="col-12 col-md-4">
            <div class="label">Proveedor:</div>
            <span class="info">
              {{ value.provider }}
            </span>
          </div>
          <div v-if="isEvaluator || isProvider" class="col-12 col-md-3">
            <div class="label">Número de Propuesta:</div>
            <span class="info">
              {{ value.proposalNumber }}
            </span>
          </div>
          <div v-if="isEvaluator || isProvider" class="col-12 col-md-3">
            <div class="label">Fecha:</div>
            <span class="info">
              {{ value.date | date }}
            </span>
          </div>
          <div v-if="isAdmin" class="col-12 col-md-5">
            <div class="label">Servicios a ofrecer:</div>
            <span class="info">
              {{ value.offeredService }}
            </span>
          </div>
          <div
            class="col-12 col-md-2 mt-4 mt-md-0 d-none d-md-flex align-items-start"
            :class="{
              'justify-content-end': isAdmin,
            }"
          >
            <dropdown
              v-if="actionItems.length > 0"
              class="actions-dropdown"
              :data-item="{ value, index }"
              :items="actionItems"
              title="Acciones"
            />
          </div>
          <div v-if="isAdmin" class="col-12 mt-4 mb-2">
            <div class="label">
              <em class="fas fa-map-marker-alt color-orange" />
              Áreas:
            </div>
            <span class="info">
              {{ value.areas }}
            </span>
          </div>
          <div
            v-if="isAdmin"
            class="col-11 bg-white border-radius--light mt-4 my-md-0 py-md-2"
          >
            <div class="label">Evaluadores:</div>
            <div class="info row px-3 mt-1">
              <div
                v-for="(evaluator, evaluatorIndex) in value.evaluations"
                :key="`${evaluator.userId}-${evaluatorIndex}-${Math.random()}`"
                class="col-12 col-md-6 p-0 evaluator_status"
              >
                <span class="evaluator_status__fullname">
                  {{ evaluator.fullName | capitalize }}
                </span>
                <custom-pill
                  class="evaluator_status__pill"
                  icon="fa-xs fas fa-circle"
                  icon-class="color-green"
                  :text="evaluator.statusName"
                />
              </div>
            </div>
          </div>

          <div class="col-12 mt-4 d-block d-md-none">
            <dropdown
              v-if="actionItems.length > 0"
              class="actions-dropdown w-100"
              :data-item="{ value, index }"
              :items="actionItems"
              title="Acciones"
            />
          </div>
        </div>
      </div>
    </div>
    <template #edition>
      <change-proposal-status-row-info
        v-if="canChangeStatus"
        :status-id="statusToBeChange.id"
        @close="closeHandler"
        @on-save-status="saveStatusHandler"
      />
      <evaluate-proposal
        v-else
        :proposal-service="value"
        @close="closeHandler"
      />
    </template>
  </custom-callout>
</template>

<script>
import CustomBalloon from 'custom-balloon';
import CustomPill from 'custom-pill';
import Dropdown from 'dropdown';
import { Colors } from '@/components/common';
import CustomCallout from 'custom-callout';
import EvaluateProposal from '@/views/provider/proposalHistory/components/EvaluateProposal';
import ChangeProposalStatusRowInfo from '@/views/provider/proposalHistory/components/ChangeProposalStatusRowInfo';
import alertMixin from 'utils/mixins/alert.mixin.js';
import {
  getEvaluationProcess,
  changeProposalStatus,
  OGPApprovalApplicationProposal,
  GetCountDocumentContract,
  registractionContractOC,
} from '@/modules/serviceProposalHistory/api';
import {
  proposalRequestStatusGroup,
  proposalRequestStatus,
} from '@/utils/constants/proposalRequestStatus.js';

import proposalEvaluationStatus from '@/utils/constants/proposalEvaluationStatus.js';

export default {
  name: 'RowStandard',
  components: {
    CustomBalloon,
    Dropdown,
    CustomPill,
    CustomCallout,
    EvaluateProposal,
    ChangeProposalStatusRowInfo,
  },
  mixins: [alertMixin],
  props: {
    colorBallon: {
      type: String,
      default: () => 'gray',
    },
    value: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: null,
    },
    accessType: {
      type: String,
      default: () => 'NoAccess',
    },
  },
  data: () => ({
    isOpen: false,
  }),
  computed: {
    statusToBeChange() {
      switch (this.value?.proposalServiceStatus.trim()) {
        case proposalRequestStatusGroup.SentBudget.name:
          return proposalRequestStatusGroup.ContractOffice;
        case proposalRequestStatusGroup.ContractOffice.name:
          return proposalRequestStatusGroup.SecretaryOffice;
        case proposalRequestStatusGroup.SecretaryOffice.name:
          return proposalRequestStatusGroup.PendingShippingOGP;
        case proposalRequestStatusGroup.PendingShippingOGP.name:
          return {
            ...proposalRequestStatusGroup.OGPApprovalApplication,
            requireExtraInfo: true,
          };
        case proposalRequestStatusGroup.OGPApprovalApplication.name:
          return proposalRequestStatusGroup.OGPApproval;
        case proposalRequestStatusGroup.OGPApproval.name:
          return proposalRequestStatusGroup.OfficeSecretaryForSignature;
        case proposalRequestStatusGroup.OfficeSecretaryForSignature.name:
          return {
            ...proposalRequestStatusGroup.ReadyForSignature,
            hasExtraValidation: true,
          };
        case proposalRequestStatusGroup.ReadyForSignature.name:
          return proposalRequestStatusGroup.SignedContract;
        case proposalRequestStatusGroup.SignedContract.name:
          return {
            ...proposalRequestStatusGroup.RegisteredContractOC,
            requireExtraInfo: true,
          };
        default: {
          return null;
        }
      }
    },
    isEvaluator() {
      return this.accessType === 'Evaluator';
    },
    isProvider() {
      return this.accessType === 'Provider';
    },
    isAdmin() {
      return this.accessType === 'Admin';
    },
    canChangeStatus() {
      return (
        this.userHasPermissions('proposal.administrator') &&
        this.statusToBeChange != null
      );
    },
    canShowDetailAction() {
      return this.userHasPermissions('provider.proposal.showdetail');
    },
    actionItems() {
      let actions = [];
      if (
        this.userHasPermissions('proposal.administrator') ||
        this.userHasPermissions('proposal.provider')
      ) {
        actions = actions.concat([
          {
            name: 'seeDetails',
            label: 'Ver Detalle',
            icon: 'fas fa-flag text-green pr-1',
            visible: this.canShowDetailAction,
            click: this.goToDetails,
          },
        ]);
      }

      if (this.canChangeStatus) {
        actions = actions.concat([
          {
            name: 'changeStatus',
            label: `Enviar a ${this.statusToBeChange.name}`,
            icon: 'fas fa-exchange-alt text-green pr-1',
            visible: true,
            click: this.changeProposalStatusConfirm,
          },
        ]);
      }

      if (
        (this.isEvaluator ||
          this.userHasPermissions('proposal.evaluator.canevaluate') ||
          this.userHasPermissions('proposal.evaluator')) &&
        [
          proposalEvaluationStatus.Pendiente,
          proposalEvaluationStatus.EnProcesoEvaluacion,
        ].includes(Number(this.value.proposalServiceStatusId))
      ) {
        actions = actions.concat([
          {
            name: 'evaluate',
            label: 'Evaluar',
            icon: 'fas fa-flag text-green pr-1',
            visible: true,
            click: this.showEvaluate,
          },
        ]);
      }
      return actions.filter((action) => action.visible);
    },
  },
  methods: {
    async changeProposalStatusConfirm() {
      const confirmMessage = `¿Está seguro ${this.statusToBeChange
        .customAction ||
        `que desea ${this.statusToBeChange.action} la propuesta`} <b>${
        this.value.proposalNumber
      }</b> ${this.statusToBeChange.question}?`;
      const answer = await this.ShowCancelModal(
        'Confirmación',
        confirmMessage,
        'Si',
        'No'
      );

      if (!answer) return;

      if (this.statusToBeChange.requireExtraInfo) {
        this.isOpen = true;
      } else {
        await this.changeProposalStatus();
      }
    },
    async saveStatusHandler(parameters, isApprovalAplication) {
      const params = {
        proposalRequestId: this.value.proposalRequestId,
        ...parameters,
      };
      if (isApprovalAplication) {
        await this.changeToStatusOGPApprovalApplication(params);
      } else {
        await this.changeToStatusRegisteredContractOC(params);
      }
    },
    async changeProposalStatus() {
      await changeProposalStatus(
        this.value.proposalRequestId,
        this.statusToBeChange.id
      )
        .then(() => {
          this.emitStatusChangeEvent();
        })
        .catch((err) => {
          this.catchHandler(err);
        });
    },
    async changeToStatusOGPApprovalApplication(params) {
      await OGPApprovalApplicationProposal(params)
        .then(() => {
          this.emitStatusChangeEvent();
        })
        .catch((err) => {
          this.catchHandler(err);
        });
    },
    async changeToStatusRegisteredContractOC(parameters) {
      await registractionContractOC(parameters)
        .then(() => {
          this.emitStatusChangeEvent();
        })
        .catch((err) => {
          this.catchHandler(err);
        });
    },
    async validateProposalReadyForSignature() {
      await GetCountDocumentContract(this.value.proposalRequestId)
        .then(async (res) => {
          if (!res.data) {
            const errMsg =
              'Faltan documentos requeridos por someter o aprobar para formalizar el contrato.';
            this.catchHandler(null, errMsg);
            return;
          }
          await this.changeProposalStatusConfirm();
        })
        .catch((err) => {
          this.catchHandler(err);
        });
    },
    emitStatusChangeEvent() {
      this.ShowToast(
        'Proceso exitoso',
        'El estatus ha sido cambiado exitosamente.',
        'success'
      );
      this.$emit('on-proposal-status-change');
    },
    catchHandler(err, errMsg = null) {
      if (err?.response != null || errMsg != null)
        this.ShowToast(
          'Alerta',
          err?.response.data.message || errMsg || 'error',
          'error',
          5000
        );
    },
    getColorStatus(proposalServiceStatusId, hex = false) {
      let color = hex ? '#D5B89A' : 'brown';

      if (
        [
          proposalRequestStatus.Evaluated,
          proposalRequestStatus.OGPApproval,
          proposalRequestStatus.SignedContract,
          proposalRequestStatus.RegisteredContractOC,
          proposalRequestStatus.InApprovalAndPOCreationProcess,
        ].includes(proposalServiceStatusId)
      ) {
        color = hex ? '#b2e3b6' : Colors.GREEN_LIGHT;
      }

      if (
        [
          proposalRequestStatus.EvaluationProcess,
          proposalRequestStatus.Submitted,
          proposalRequestStatus.PendingShippingOGP,
          proposalRequestStatus.OGPApprovalApplication,
          proposalRequestStatus.RecommendedCondition,
          proposalRequestStatus.SecretaryOffice,
          proposalRequestStatus.PreliminaryRecommended,
          proposalRequestStatus.RegistryComptrollerOffice,
        ].includes(proposalServiceStatusId)
      ) {
        color = hex ? '#F8EA80' : Colors.YELLOW;
      }

      if (
        [
          proposalRequestStatus.ReadyForSignature,
          proposalRequestStatus.NotRecommended,
          proposalRequestStatus.Returned,
          proposalRequestStatus.FundSeparation,
          proposalRequestStatus.RecommendedHiring,
        ].includes(proposalServiceStatusId)
      ) {
        color = hex ? '#DDB3D7' : Colors.VIOLET;
      }

      if (
        [
          proposalRequestStatus.Assigned,
          proposalRequestStatus.OfficeSecretaryForSignature,
          proposalRequestStatus.ContractOffice,
          proposalRequestStatus.Recommended,
          proposalRequestStatus.ContractDrafting,
        ].includes(proposalServiceStatusId)
      ) {
        color = hex ? '#FCC9C8' : Colors.PINK;
      }

      if (
        [
          proposalRequestStatus.SentOGP,
          proposalRequestStatus.SentToSecretaryOffice,
          proposalRequestStatus.Signed,
        ].includes(proposalServiceStatusId)
      ) {
        color = hex ? '#A3E5B3' : Colors.CELADON;
      }

      if (
        [
          proposalRequestStatus.InSigningProcessSAEE,
          proposalRequestStatus.InSigningProcessSupplier,
          proposalRequestStatus.InSigningProcessSecretary,
          proposalRequestStatus.InSigningProcessLegalDivision,
        ].includes(proposalServiceStatusId)
      ) {
        color = hex ? '#F8B184' : Colors.AUTUMN_MIST;
      }

      if (
        [proposalRequestStatus.PendingOGP].includes(proposalServiceStatusId)
      ) {
        color = hex ? '#FAE76F' : Colors.HONEY_LIGHT;
      }

      return color;
    },
    async showEvaluate() {
      if (
        proposalEvaluationStatus.EnProcesoEvaluacion ==
        this.value.proposalServiceStatusId
      ) {
        this.isOpen = true;
        return;
      }
      await getEvaluationProcess()
        .then(() => {
          this.isOpen = true;
        })
        .catch((err) => {
          if (err.response != null)
            this.ShowToast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
    closeHandler() {
      this.isOpen = false;
    },
    goToDetails({ value }) {
      this.$router.push({
        name: 'ServiceProposalDetails',
        params: {
          proposalRequestId: value.proposalRequestId,
          readOnly: false,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/fonts.scss';
@import '~@/shared/scss/config/colors.scss';

.label {
  font-weight: normal;
  font-size: 0.875rem;
  color: map-get($colors, 'secondary-6');
}

.info {
  font-weight: normal;
  color: map-get($colors, 'black');
}

.evaluator_status {
  color: map-get($colors, 'black');
  font-weight: normal;

  &__fullname {
    font-size: 1rem;
  }

  &__pill {
    width: 100px;
    font-size: 0.75rem;
    display: inline;
    margin-left: 0.5em;
  }
}

@media only screen and (max-width: 768px) {
  .actions-dropdown {
    ::v-deep {
      .dropdown-toggle {
        width: 100%;
        font-size: 0.875rem;
      }
    }
  }
}
</style>
